import PropTypes from 'prop-types'
import React, {Children, Component} from 'react'
import Submit from "./Submit"

function gtag_report_conversion(url) {
    var callback = function () {
      if (typeof(url) != 'undefined') {
        window.location = url;
      }
    };
    typeof window !== "undefined"  && window.gtag('event', 'conversion', {
            'send_to': 'AW-803806917/c1tXCJi3ppABEMW9pP8C',
            'event_callback': callback
        });
    
    return false;
}

export default class Form extends Component {

    static propTypes = {
        title: PropTypes.string,
        description: PropTypes.node,
        submit: PropTypes.string,
    }

    constructor(props) {
        super(props)
        this.state = {}

        this.handleFormChange = this.handleFormChange.bind(this)
        this.handleFormSubmit = this.handleFormSubmit.bind(this)
    }

    render() {
        const {title, description, submit, children} = this.props

        const mapChildrenWithProps = children => Children.map(children, cloneChildWithProps.bind(this))
        const cloneChildWithProps = child => React.cloneElement(child, {
            onChange: this.handleFormChange,
            value: this.state[child.props.name],
        })

        return (
            <form action="#" className="form" onSubmit={this.handleFormSubmit} id="form">
                {title ? <h2>{title}</h2> : null}
                {description ? <p dangerouslySetInnerHTML={description}/> : null}
                {mapChildrenWithProps(children)}
                <Submit text={submit}/>
            </form>
        )

    }

    handleFormChange(event) {
        const target = event.target
        const value = target.value
        const name = target.name

        this.setState({
            [name]: value,
        })
    }

    handleFormSubmit(event) {
        event.preventDefault()

        document.getElementById('form').innerHTML = '<h2 id="form">Sending Message</h2>'

        if (typeof window !== `undefined`) {
            // let subject = `${this.state.name} needs your assistance!`
            let subject = `${this.state.name} from ${this.state.company} - LocusLabs.com contact form request`
            let body = `
This contact form was submitted at ${Date().toString()}.

Referring URL: ${window.location.href}

IP address: ${window.ip}
`

            Object.keys(this.state).map(key => {
                body += `\n${key}: ${this.state[key]}`
            })

            let data = {
                destination: {
                    to: ['info'],
                },
                message: {
                    subject: subject,
                    body: body,
                },
                replyTo: ["info"],
                source: "info",
            }

            window
                .fetch('https://obw4r044f2.execute-api.us-west-2.amazonaws.com/prod/v1/email', {
                    method: 'POST',
                    body: JSON.stringify(data),
                    headers: {
                        'Accept': 'application/json, text/plain, */*',
                        'Content-Type': 'application/json',
                    },
                })
                .then(function (response) {
                    return response.json()
                })
                .then(function (data) {
                    console.log('Email Sent:', data)
                    document.getElementById('form').innerHTML = '<h2 id="form">Message Sent</h2>'
                    window.dataLayer = window.dataLayer || []
                    gtag_report_conversion()
                })
        }
    }

}



// WEBPACK FOOTER //
// ./src/components/form/Form.js